import gql from 'graphql-tag'

export default gql`
  query getNewsletterSubscribers {
    getNewsletterSubscribers {
      id
      email
      enabled
    }
  }
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/newsletter-subscriber/get.js